import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-auto-selection-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './auto-selection-card.component.html',
  styleUrls: ['./auto-selection-card.component.scss'],
})
export class AutoSelectionCardComponent {
  @Output() goToLibrary = new EventEmitter<void>();
}
